export const SET_NOTIFICATION_INTERVAL = 'set-notification-interval';
export const SET_INITIAL_SETTINGS = 'set-initial-settings';
export const TOGGLE_DARK_MODE = 'toggle-dark-mode';

const settingsReducer = (state, action) => {
  switch (action.type) {
    case SET_NOTIFICATION_INTERVAL: {
      const { interval } = action;
      if (!Number.isNaN(parseInt(interval, 10)) && /^\d+$/.test(interval)) {
        return { ...state, interval: parseInt(interval, 10) };
      } if (interval === '') {
        return { ...state, interval: '' };
      }
      return { ...state, interval: '' };
    }
    case SET_INITIAL_SETTINGS: {
      return action.data ? action.data : state;
    }
    case TOGGLE_DARK_MODE: {
      return { ...state, isDarkMode: state.isDarkMode === 1 ? 0 : 1 };
    }
    default:
      return state;
  }
};

export { settingsReducer };
